import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Cannot Be Delegated field definition
 * Boolean field with Yes/No dropdown for sensitive (cannot be delegated) status filtering
 */
export const ADObjectCannotBeDelegated = createBooleanSimpleFilterDefinition(
  'sensitive',
  'Cannot Be Delegated'
);
